/**
 * Delivery time options, fetched live instead of baked into the template.
 *
 * The windows changed three times in three days, and each change was an edit in
 * the iOS app, the Flutter app and this theme, plus a build and a store review.
 * They now live in one Firestore document that the apps listen to and that this
 * endpoint serves as JSON, because the theme has no Firebase in it and cannot
 * read Firestore itself.
 *
 * THE TEMPLATE'S OWN CHOICES ARE THE FALLBACK AND MUST STAY. If this fetch
 * fails, is slow, or returns nothing usable, the server-rendered options in
 * templates/product.floral.json stand and the customer never knows. A dead
 * endpoint degrades to the old behaviour, never to an empty picker.
 *
 * Classic script, not a module, matching delivery-date.js and
 * floral-cardstock-addon.js. Loaded site-wide from layout/theme.liquid, which is
 * the only script path in this theme that has proved reliable.
 */
(function () {
  "use strict";

  var ENDPOINT = "https://us-central1-twelve-thirty-four.cloudfunctions.net/deliveryWindows";

  /** The select the delivery_time block renders. */
  function findSelect(root) {
    return (root || document).querySelector(
      'product-custom-property-component[id$="__delivery_time"] select'
    );
  }

  function apply(select, data) {
    var windows = (data && data.windows) || [];
    if (!windows.length) return;

    // Never overwrite a choice somebody has already made. The script runs on
    // load and again after a section re-render, and a customer who picked a
    // time before the fetch landed must not have it silently swapped.
    if (select.value) return;

    var placeholder = select.querySelector('option[value=""]');
    var callOption = null;
    // Keep whatever the template called the call-or-email choice rather than
    // re-writing its wording here. Two places spelling it differently is how
    // the label the order importer parses drifts.
    for (var i = 0; i < select.options.length; i++) {
      var v = select.options[i].value;
      if (v && !/\d/.test(v)) { callOption = select.options[i]; break; }
    }

    select.innerHTML = "";
    if (placeholder) select.appendChild(placeholder);
    windows.forEach(function (w) {
      if (!w || !w.label) return;
      var opt = document.createElement("option");
      // The LABEL is the value, because that is what lands on the order as a
      // line item property and what the admin parses a start hour out of.
      opt.value = w.label;
      opt.textContent = w.label;
      select.appendChild(opt);
    });
    if (callOption && data.allowCallToConfirm !== false) select.appendChild(callOption);
  }

  var cached = null;

  /**
   * One request for the page. delivery-date.js reads the same answer for its
   * closed days, so whichever script asks first makes the call and the other
   * shares it. Resolves null on any failure, never rejects.
   */
  function hours() {
    if (!window.__ttfDeliveryHours) {
      window.__ttfDeliveryHours = fetch(ENDPOINT, { method: "GET", mode: "cors" })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; })
        .then(function (data) {
          // A failure is not kept, so the next re-render asks again.
          if (!data) window.__ttfDeliveryHours = null;
          return data;
        });
    }
    return window.__ttfDeliveryHours;
  }

  function scan(root) {
    var select = findSelect(root);
    if (!select || select.dataset.windowsWired === "1") return;
    select.dataset.windowsWired = "1";

    if (cached) { apply(select, cached); return; }

    hours()
      .then(function (data) {
        if (!data) return;
        cached = data;
        apply(select, data);
      })
      .catch(function () {
        // Deliberately silent. The template's options are already on screen and
        // are correct often enough; an error here is not the customer's problem.
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { scan(); });
  } else {
    scan();
  }

  // Horizon re-renders the product form on a variant change, which replaces the
  // select and loses the wiring. Same reason delivery-date.js listens here.
  document.addEventListener("shopify:section:load", function (e) { scan(e.target); });
  document.addEventListener("variant:update", function () { scan(); });
})();
